import React, { useState, useEffect, useRef, useContext } from "react";
import * as Constants from "../../constants";
import BackLoader from "../../components/backloader";
import JisButton from "../controls/jisButton";
import { ShareContext } from "../../context/ShareContext";
import JisDialogForm from "../formdialog";
export default function JisInternalPay({
  isPay,
  name,
  email,
  phone,
  externalAmount,
  internalAmount,
  ref,
  note,
  docuploadid = null, // null = no document yet (a new bill is always created)
  onCancel,
  children,
}) {
  const { activePage, token, profile, frequentData, setIsExpired } =
    useContext(ShareContext);
  const [gateway, setGateway] = useState(null);
  const [loading, setLoading] = useState(false);
  const [payinfo, setPayInfo] = useState(null);
  //const [billRef, setBillRef] =useState(null);
  const billRef = useRef(null);
  const formRef = useRef();
  const [pi, setPi] = useState([]);
  //const billRef = useRef()

  useEffect(() => {
    onLoad();
  }, []);

  useEffect(() => {
    if (!ref) {
      const _pi = note?.split("-");
      console.log(_pi);
      setPi(_pi);
    }
  }, [note, ref]);

  const onLoad = async () => {
    //for account registration
    const url = `${Constants.apiUrl}/payment/current-gateway`;
    console.log(`the calling url ${url}`);
    try {
      setLoading(true);
      const resp = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = await resp.json();

      setLoading(false);
      console.log(data);
      if (data.code === 0) {
        setGateway(data.current);
      } else {
        alert(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const ProcessPay = async () => {
    /* if (ref) {
      handlePayment(ref);
      return;
    } */

    setLoading(true);

    try {
      var payinfo = {
        id: 0,
        payType: "pay4it",
        note,
        amount:(internalAmount+externalAmount),
        gatewayId: gateway.id,
        isPaid: false,
        divisionId: pi[5],
        docuploadid: docuploadid > 0 ? docuploadid : null,
        externalAmount: externalAmount,
        internalAmount: internalAmount,
      };
      const resp = await fetch(
        `${Constants.apiUrl}/payment/initiate-internal-pay`,
        {
          method: "POST",
          body: JSON.stringify(payinfo),
          headers: {
            "Content-Type": "application/json, text/plain",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await resp.json();
      setLoading(false);
      console.log(data);
      if (data.code === 0) {
        //setGazettes(data.gazettes);
        console.log("bill... " + data);
        var bill = data.id;
        billRef.current = bill;
        var billWithPrefix = `JISI${bill}`;
        localStorage.setItem("internalid", billWithPrefix);

        if(gateway?.name == "Pay4it"){
          handlePayment(bill);
        }else if(gateway?.name == "e-Transact"){
          window.location = data.etrans_url;
        }
        

        // if (gateway?.name == "Pay4it") {
        //   window.location = `https://usepay4it.com/payment/collection/mda?mda=${Constants.pay4it_key}&callbackUrl=${Constants.payment_callback_internal}&internalBillReference=${bill}`;
        // } else if (gateway?.name == "Paystack") {
        //   window.location = `${
        //     Constants.baseurl
        //   }/paystack.html?name=${name}&email=${email}&phone=${phone}&returnurl=${`${Constants.payment_callback_internal}/`}&amount=${amount}&docref=${bill}`;
        // }

        //window.location=`https://usepay4it.com/payment/collection?mda=${Constants.pay4it_key}&tx_reference=${data.webGuid}&callbackUrl=${Constants.pay4it_callback}`;
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      // setErr(Constants.serverErr);
      // onMove();
    }
  };

  const handlePayment = async (transactionRef) => {
    const bill = `JISI${transactionRef}`;

    if (gateway?.name == "Pay4it") {
      window.location = `https://usepay4it.com/payment/collection/mda?mda=${Constants.pay4it_key}&callbackUrl=${Constants.payment_callback_internal}&internalBillReference=${bill}`;
    } else if (gateway?.name == "Paystack") {
      window.location = `${
        Constants.baseurl
      }/paystack.html?name=${name}&email=${email}&phone=${phone}&returnurl=${`${Constants.payment_callback_internal}/`}&amount=${(internalAmount+externalAmount)}&docref=${bill}`;
    }
  };

  const onPay4it = () => {
    //process pay for it link here
    if (formRef.current) {
      formRef.current.requestSubmit(); // preferred over formRef.current.submit()
    }
  };
  //swtich happen here
  return (
    isPay && (
      <JisDialogForm title="Payment" minWidth="20%" onClose={onCancel}>
        <div className="success-payment-wrapper">
          <h2>Make Payment</h2>
          <p>
            Total Amount Payable <br />
            {Constants.formatCurrency((internalAmount*1)+(externalAmount*1))}
          </p>
          <div className="confirm-upload-btns">
            <button
              id="payNow_btn"
              className="process-btn "
              onClick={ProcessPay}
            >
              Pay Now
            </button>
            {/* <button className="" onClick={onCancel}>
              Pay Later
            </button> */}
          </div>
        </div>
        <BackLoader open={loading} />
      </JisDialogForm>
    )
  );
}
